export default __webpack_public_path__ + "static/damixa--mobile@1x-ed87d36e17faefcf7adb87cff3b302e6.jpg";